import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const AddTypoSquattingProjectFetcher = (accessToken, organizationUid, params) => {
  return axios.post(
    `${apiUrlInternal}/typosquatting_projects/organizations/${organizationUid}`,
    params,
    addAuthToFetchOpts(accessToken, {})
  ).then(res => res.data);
}

export const useAddTypoSquattingProject = (fetcher = AddTypoSquattingProjectFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['add-organization-typosquatting-project'],
    (accessToken, {params, organizationUid}) => fetcher(accessToken, organizationUid, params),
    {
      onSuccess: (_, {organizationUid}) => {
        queryClient.invalidateQueries('add-organization-typosquatting-project');
        queryClient.invalidateQueries(['project-typosquatting', organizationUid]);
      }
    }
  )
}
